import React, { useContext, useEffect, useState } from "react";
import AlertContext from "../Contexts/AlertContext";
import { authFileRequest, fileRequest, normal, props } from "../APIs/api";
import AuthContext from "../Contexts/AuthContext";
import AlertTypes from "../Enums/AlertTypes";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NavContext from "../Contexts/NavContext";
import { useNavigate } from "react-router-dom";
import VerificationInput from "react-verification-input";
import { loginWithTelebir } from "../APIs/AuthAPI";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';


const CreateAccount = () => {

    const {currentOrder, updateCurrentOrder, openAlert, setWaiting} = useContext(AlertContext);
    const {isLoggedIn, cookies, setLoggedUser, setCookie, setLoggedIn, loggedUser} = useContext(AuthContext);
    const {selectNav} = useContext(NavContext);

    const navigate = useNavigate();
    const [passwordVisibility, setPasswordVisibility] = useState<Boolean>(false);
    const [confirmPasswordVisibility, setConfirmPasswordVisibility] = useState<Boolean>(false);
    const [otpPopup, setOtpPopup] = useState<boolean>(false);
    const [inputs, setInputs] = useState<any>({
        name: "",
        phone: "",
        password: "",
        confirm_password: "",
        verification_otp: ""
    })

    useEffect(() => {

        if(isLoggedIn || loggedUser) {
            navigate("/home"); (selectNav && selectNav("home"));
        }

    }, [currentOrder]);

    const submit = async () => {

        try {

            await normal().bodyRequest("post", "crud/create", {
                tableName: "user",
                data: { ...inputs, phone: `+251${inputs.phone}` }
            });
    
            openAlert(AlertTypes.Success, ("Now you are registered successfully. Please login to get our services."));
            navigate("/sign_in");
            selectNav && selectNav("home");

        } catch(error: any){
            openAlert(AlertTypes.Error, error.message); 
        }
    }

    const askPhoneVerification = async () => {

        let fullname_validator = /[0-9\*&<>=@'"!)(\[\])^$#|?\.,\{\}%_\-\+]/g;
        let phone_validator = /[a-zA-Z\*&<>=@'"!)(\[\])^$#|?\.,\{\}%_\-]/g;

        setTimeout(() => {setWaiting(true);}, 1);

        try {

            if(fullname_validator.test(inputs.name)) {
                throw new Error("Name should not contain special characters and numbers.");
            }

            if(phone_validator.test(inputs.phone)) {
                throw new Error("Phone should not contain special characters and alphabet characters.");
            }

            if(inputs.password != inputs.confirm_password) {
                throw new Error("password does not match");
            }

            if(inputs.password == "") {
                throw new Error("please create your password!");
            }

            await normal().bodyRequest("post", "crud/verify_phone", {phone: `+251${inputs.phone}`});
            setOtpPopup(true);

        } catch(error: any){
            openAlert(AlertTypes.Error, error.message); 
        }

        setTimeout(() => {setWaiting(false);}, 1);
    }

    const inputChange = (event: any) => {
        setInputs((npt: any) => ({...npt, [event.target.name]: event.target.value}))
    }

    const continueWithTelebir = async () => {

        try {

            window.handleinitDataCallback = async (token: any) => {
                let response = await loginWithTelebir(token);
                setLoggedUser(response);
                setCookie("login_token", response.Token, { path: "/", secure: true, maxAge: 900 });
                setLoggedIn(true);
                navigate("/account");
            };

            let obj = JSON.stringify({
                functionName: "js_fun_h5GetAccessToken",
                params: {
                    appid: "1250715428992001",
                    functionCallBackName: "handleinitDataCallback",
                },
            });

            window.consumerapp.evaluate(obj);

        } catch(error: any) {
            openAlert(AlertTypes.Error, error.message);
        }

    }

    return (
        <div className="w-100 h-100 px-3 pt-3" style={{position: "relative", overflow: "hidden auto"}}>
            <h1 className="card-title text-center mb-2">Sign Up</h1>
            {
                window.consumerapp && (
                    <>
                        <p className="lead mb-1 text-center">Use Continue with telebirr if you want to use your telebir profile.</p>
                        <div className="nuwa-card d-flex justify-content-center nuwa_panel mb-3" 
                            style={{borderRadius: "20px", cursor: "pointer", padding: "13px"}}
                            onClick={continueWithTelebir}
                        >
                            <img src="/images/Telebirr.png" alt="telebirr logo" className="me-3" style={{width: "70px"}} />
                            <span className="ms-3 fs-5">Continue with telebirr</span>
                        </div>
                    </>
                )
            }
            <p className="lead mb-2 text-center">If you want to create your account manully you can fill the following fields and submit.</p>

            <span className="card-title lead"><b> Phone Number</b></span>
            <div className="d-flex nuwa-search-container mb-3 nuwa_panel" style={{padding: "10px", paddingRight: "5px"}}>
                <span className="card-subtitle me-2">+251</span>
                <input type="text" value={inputs.phone} name="phone" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Phone Number to Contact You" />
            </div>

            <span className="card-title lead"><b> Full Name</b></span>
            <div className="nuwa-search-container mb-4 nuwa_panel" style={{padding: "10px", paddingRight: "5px"}}>
                <input type="text" name="name" value={inputs.name} onChange={inputChange} className="nuwa-search-input w-100" placeholder="Your Full Name" />
            </div>

            <p className="lead mb-2 text-center">The password you are about to enter needs to be succured should be known only by you. After entering your password in the first input write the same password on the confirmation input password.</p>

            <span className="card-title lead"><b>New Password</b></span>
            <div className="nuwa-search-container mb-3 nuwa_panel d-flex" style={{padding: "10px", paddingRight: "5px"}}>
                <input type={passwordVisibility ? "text" : "password"} value={inputs.password} name="password" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Create Password" />
                <button className="btn btn-sm" onClick={() => {setPasswordVisibility(!passwordVisibility)}}>
                    {passwordVisibility ? (<VisibilityOffIcon sx={{fontSize: "20px"}} />) : (<RemoveRedEyeIcon sx={{fontSize: "20px"}} />)}
                </button>
            </div>

            <span className="card-title lead"><b>Confirm Password</b></span>
            <div className="nuwa-search-container mb-3 nuwa_panel d-flex" style={{padding: "10px", paddingRight: "5px"}}>
                <input type={confirmPasswordVisibility ? "text" : "password"} value={inputs.confirm_password} name="confirm_password" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Confirm Your Password" />
                <button className="btn btn-sm" onClick={() => {setConfirmPasswordVisibility(!confirmPasswordVisibility)}}>
                    {confirmPasswordVisibility ? (<VisibilityOffIcon sx={{fontSize: "20px"}} />) : (<RemoveRedEyeIcon sx={{fontSize: "20px"}} />)}
                </button>
            </div>

            <button className="nuwa-white-btn py-2 px-2 text-center w-100" onClick={askPhoneVerification} >
                Submit
            </button>

            {

                otpPopup && (
                    <div className="h-100 w-100 px-3 justify-content-center"
                        style={{background: "rgba(0, 0, 0, 0.5)", display: "flex", flexDirection: 'column', position: "absolute", top: 0, left: 0, zIndex: 500}}>

                            <div className="w-100 nuwa_group">
                                <div className="nuwa-card p-3 w-100" style={{borderRadius: "30px", backdropFilter: "blur(35px)"}}>

                                    <h1 className="card-title text-center mb-2">Verify You Phone</h1>
                                    <p className="lead mb-3 text-center">We have sent 4 digit token using sms to the number ****{inputs.phone.substring((inputs.phone.length-3), inputs.phone.length)}</p>

                                    <div className="nuwa-search-container w-100 d-flex justify-conetent-center mb-5 nuwa_panel" style={{padding: "10px", paddingRight: "5px"}}>
                                        <div className="col"></div>
                                        <div style={{width: "max-conent"}}>
                                            <VerificationInput value={inputs.verification_otp} onChange={(value) => {setInputs({...inputs, verification_otp: value})}} />
                                        </div>
                                        <div className="col"></div>
                                        {/* <input type="text" name="full_name" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Your Full Name" /> */}
                                    </div>

                                    <button className="nuwa-white-btn py-2 px-3 text-center w-100 mb-2 text-start shadow-sm bg-dark text-white"
                                        disabled={inputs.verification_otp.length < 6}
                                        onClick={submit}
                                    >
                                        Verify
                                    </button>

                                    <button className="nuwa-white-btn py-2 px-3 text-center w-100 bg-dark text-white" onClick={() => {setOtpPopup(false)}}>Cancel</button>

                                </div>
                            </div>
                    </div>
                )

            }

        </div>
    );

};

export default CreateAccount;